/**
 * Workspace billing tier — UI string ↔ API enum bridge.
 *
 * The API models the tier as the numeric `WorkspaceTier` enum, but the
 * workspace edit toggle and the workspace-list chip both work in these
 * lowercase strings. These two helpers are the single conversion point.
 */

import { WorkspaceTier } from '../apis/api-client';

/** Billing tier of the workspace. Drives which premium features the
 *  tenant admin can use and surfaces a label on the workspace list so
 *  sales/support can spot enterprise vs. trial accounts at a glance. */
export type AccountType = 'standard' | 'enterprise' | 'demo';

export function tierToAccountType(tier: WorkspaceTier | undefined | null): AccountType {
  switch (tier) {
    case WorkspaceTier.Enterprise:
      return 'enterprise';
    case WorkspaceTier.Demo:
      return 'demo';
    default:
      return 'standard';
  }
}

export function accountTypeToTier(accountType: AccountType): WorkspaceTier {
  switch (accountType) {
    case 'enterprise':
      return WorkspaceTier.Enterprise;
    case 'demo':
      return WorkspaceTier.Demo;
    default:
      return WorkspaceTier.Standard;
  }
}
